import { Box } from "@mui/material";
import useWindowDimensions from "../../../shared/hooks/useWindowDimensions";
import useStyles from "./style";
import mainImage from "../../../assets/images/mainImage.jpg";
import Snowfall from "react-snowfall";
import { Link } from "react-router-dom";
import Logo from "../../../assets/images/logo.png";

interface IBanner {
  bannerRef: any;
}

const Banner = ({ bannerRef }: IBanner) => {
  const classes = useStyles();
  const { innerWidth } = useWindowDimensions();

  return (
    <div className={classes.main}>
      <Snowfall
        color="white"
        style={{ zIndex: 1, opacity: 0.5 }}
        snowflakeCount={300}
        radius={innerWidth < 991 ? [2, 5] : [3, 10]}
      />
      <Box ref={bannerRef} className={classes.image}>
        <img src={mainImage} alt="logo" />
        <Link to="/">
          <Box
            sx={{
              position: "absolute",
              top: "6%",
              left: "7%",
              transform: "scale(1.5)",
            }}
          >
            <img src={Logo} alt="logo" className={classes.logo} />
          </Box>
        </Link>
        <Box className={classes.textSide}>
          <div className={classes.bluredCarouselSliderTextArea}>
            <Box padding="22px">
              <h2 className={classes.title}>Դարձիր բարեգործ</h2>

              <p className={classes.description}>
                Գնիր ամանորյա բացիկ և նվիրիր առողջություն արցախցի երեխաներին
              </p>
            </Box>
          </div>
        </Box>
      </Box>
    </div>
  );
};

export default Banner;
